import React, { Fragment, useState, useEffect, useContext } from "react";
import { SessionContext } from '../context/sessionContext';

import { Collapse, Form, Row, Col, Button } from "react-bootstrap";

import DatePicker from "react-datepicker";
import Modal from 'react-bootstrap/Modal';

import "react-datepicker/dist/react-datepicker.css";

import SelectInput from "./selectInput";

import TablaCampos from "./tablaCampos";

import MapExpedientes from "./map_expedientes";

import useNomenclador from "../hooks/useNomenclador";

import {optionsResponsable, optionsPrograma, optionsEstado, optionsTipo, optionsPartido, optionsTitular, optionsPlano, optionsArea, optionsSistemaAgua, optionsEliminacionExcret } from "../datos/options";

/*
EX 19-09-2026 (fase 2 - paso 3) - FORMULARIO UNICO de la pestaña "Datos del expediente".

Antes habia DOS copias de este formulario: datosExp.js (alta) y datosEditExp.js (edicion). Habian
divergido en 76 bloques de codigo: la mayoria cosmeticos (var/let, name vs e.target.name, espacios,
puntos y coma), pero con diferencias reales mezcladas entre ellos. Ahora hay un solo componente y las
diferencias reales son props de CAPACIDAD: no hay ningun `modo === 'alta' ? ... `.

El default de todas las capacidades es el ALTA, asi que expediente.js no pasa ninguna prop y
grupo_editexpiente.js pasa las que necesita.

  precargarDatos      - el formulario muestra los valores que ya trae `inputs` (la edicion carga un
                        expediente existente). Donde el campo es controlado se pasa `value`, donde es
                        no controlado se pasa `defaultValue`. Con false no se pasa NINGUNO de los dos:
                        asi estaba el alta, y no es lo mismo que pasar un valor vacio, porque un
                        defaultValue se aplica al montar y el alta no se tiene que "acordar" de un
                        expediente que se cargo antes.
                        Ojo: hay cinco selects (responsable, programa, estado, tipo y partido) que
                        llevan defaultValue SIEMPRE, tambien en el alta: el alta ya lo tenia activo
                        (con el valor vacio o 0 con el que arranca `inputs`), asi que ahi NO va
                        valorInicial(): sacarselo cambiaria cual queda seleccionado.
  partidoBloqueado    - el select de Partido no se puede cambiar. En la edicion la nomenclatura depende
                        del partido: las filas de DATOS CATASTRALES Y DOMINIALES guardan su propio
                        nomencla_partido, asi que cambiarlo dejaria esos datos apuntando al partido
                        anterior. Ademas deja el nomenclador simple: circ se pide una vez y las
                        secciones al elegir la circ. Para cambiar de partido hay que dar de alta un
                        expediente nuevo.
  fechasTalCualVienen - las dos fechas deshabilitadas se muestran con el valor tal como viene en
                        `inputs`. El alta, en cambio, las convierte a hora local (_fechaCarga/_fechaHoy)
                        porque su fecha_carga arranca como new Date(). Hoy las dos formas NO muestran lo
                        mismo para un valor guardado en la base (ver TEMAS_PENDIENTES): quedan por flujo
                        para no cambiar ninguna de las dos en este paso.
  tituloMapa          - titulo del modal del mapa ("Nuevo polígono" / "Editar polígono").
  sufijoId            - sufijo de los ids del DOM que hoy siguen siendo distintos por flujo
                        (input_A/input_AE, input_B/input_BE, id_modal_map/id_modal_mapE). Es herencia de
                        cuando los dos formularios convivian en la misma pagina; ahora hay uno solo
                        montado por vez, asi que se puede borrar (queda para 3c).
  (3b) La unica prop de geometria por flujo (layoutHeredado) YA NO EXISTE: se borro al converger la fila
       del nomenclador a una sola proporcion y al sacar el separador de 84px que tenia la edicion. Este
       formulario hoy no tiene NINGUNA geometria que dependa del flujo.

Micro-unificaciones deliberadas en este paso. Son las UNICAS diferencias visibles que introduce la
fusion, y estan todas para el lado del texto/atributo inerte:

  - label de fecha_carga: "Fecha carga" (alta) -> "Fecha de carga" (que ya decia la edicion).
  - label del geojson: se saca el "--" que arrastraba el alta (solo se ve con el usuario javi1).
  - label "Última actualización": en la edicion su `for` apuntaba a fecha_carga, o sea al input
    equivocado (dos inputs mas a la izquierda) -> ahora apunta a fecha_actualizacion.
  - input de zonificacion: la edicion usaba id="id_zonificacion" y el alta id="zonificacion" -> queda
    "zonificacion", igual que el `name`, como el resto de los inputs de texto. Ningun CSS usa ese id
    (verificado en index.css).
  - se saca title="EN REVISION" del boton "+" (era un tooltip de depuracion).
  - se sacan los atributos `alt` y `placeholder` de los <label>: no son validos en un label, ningun
    CSS los usa (verificado) y la edicion ya los ignoraba.
  - se saca el onChange de las dos fechas deshabilitadas (lo tenia solo la edicion): con `disabled` es
    inalcanzable y ademas recibia un Date, no un evento (e.target seria undefined y reventaria).
  - se saca el onClick del input de zonificacion (lo tenia solo la edicion): su cuerpo era un
    comentario, no hacia nada.
  - el input de porcentaje de lotes municipales: la edicion no tenia step="1" y el alta si -> queda
    step="1", que es el valor por defecto de un input type=number (no cambia nada).
  - las className / id / style / title que se le pasan a los SelectInput quedan como estaban en el alta
    (varias comentadas). Son inertes: SelectInput NO recibe esas props en su firma y su <select> tiene
    un className literal, asi que las descarta. Es el motivo por el que "form-control my-3" no hacia
    nada en las pantallas donde estaba activo. Queda anotado para 3b (o se borran o SelectInput empieza
    a respetarlas, pero eso si cambiaria el layout).

Lo que NO se toco en este paso, a proposito: el codigo muerto de cada flujo (handleClose,
onChangeConsulta, TextInput, activateField/disableField, los estados que solo se escriben) sigue
estando, tal cual estaba. Sacarlo es un cambio aparte (3c) para que se pueda verificar solo.
*/

//EX 19-09-2026 (fase 2 - paso 3b): aca estaban LAYOUT_ALTA y LAYOUT_EDICION, con los anchos de la fila
//del nomenclador (alta 60/25/25/10 y edicion 40/25/40/sin ancho) y el separador de 84px de la edicion.
//Se borraron: la fila quedo con una sola geometria proporcional (ver el JSX) y el separador se fue.
//La prop `layoutHeredado` tambien desaparecio, o sea que este formulario ya NO tiene geometria por flujo.

const DatosExp = ({
	name, inputs, setInputs, formRows, setFormRows, setErrorD,
	precargarDatos = false,
	partidoBloqueado = false,
	fechasTalCualVienen = false,
	tituloMapa = "Nuevo polígono",
	sufijoId = ""
}) => {

	const nameLogin = name;

	//EX 19-09-2026 (fase 2 - paso 3c): de estos cinco, `original` y `defaultValue` no se usaron nunca y
	//`cambioGeom` solo lo usaba handleClose, que tambien se borro.
	const { cambioOriginal, geom } = useContext(SessionContext);

	//La edicion precarga los campos con lo que ya trae `inputs`. El alta no pasa nada (devuelve
	//undefined, que para React es "campo no controlado y sin valor inicial").
	const valorInicial = (valor) => (precargarDatos ? valor : undefined);

	//Los ids que hoy siguen teniendo sufijo por flujo. Con sufijoId = '' dan los del alta.
	const idInputPorc = `input_A${sufijoId}`;
	const idInputLotes = `input_B${sufijoId}`;
	const idModalMapa = `id_modal_map${sufijoId}`;

	const {
		nombre_proyecto,
		fecha_carga,
		fecha_caratulacion,
		fecha_actualizacion,
		datos_05_responsable, expediente,
		tramite_prioritario, avanzados,
		programa, estado, tipo, partido, localidad,
		cantidad_lotes, cantidad_lotes_adjudicables, porc_lotes_municipales, lotes_adquiridos_municipio,
		datos_18_sintesis_nomenclatura,
		titular_tierra, plano_oficial, area, zonificacion,
		nro_ordenanza_vigente, decreto_promulgatorio, sistema_agua, eliminacion_excretas, observaciones_generales,
		datos_20_circ_nomencla,
		datos_21_secc_nomencla
	} = inputs;

	//EX 19-09-2026 (fase 2 - paso 3c): aca estaba `const [fechaHoy, setFechaHoy] = useState(new Date('2014-01-01'))`.
	//Nunca se llamaba al setter y nadie leia el valor: la fecha que se muestra es `_fechaHoy`, que se calcula
	//abajo a partir de fecha_actualizacion. Se borro.

	let _fechaHoy = null;
	if (fecha_actualizacion===null) {
		_fechaHoy = null;
	} else if (fecha_actualizacion !== null || fecha_actualizacion !== ""){
		_fechaHoy = new Date(fecha_actualizacion);
		_fechaHoy.setMinutes(_fechaHoy.getMinutes() + _fechaHoy.getTimezoneOffset())
	}

	let _fechaCarga = null;
	if (fecha_carga=== null) {
		_fechaCarga = null;
	} else if (fecha_carga !== null || fecha_carga !== ""){
		_fechaCarga = new Date(fecha_carga);
		_fechaCarga.setMinutes(_fechaCarga.getMinutes() + _fechaCarga.getTimezoneOffset())
	}

	//EX 19-09-2026 (fase 2 - paso 3c): se borraron tres cosas que no hacian nada:
	//  - los refs textAreaNomenclaSintesis / textAreaObsGrales: se pasaban al textarea pero nunca se leia
	//    `.current` (los textarea se manejan solos);
	//  - los estados valNomencSintesis / valObserGrales: se llamaba al setter en el onChange, pero nadie
	//    leia el valor;
	//  - valGeom / setValGeom: al setter no se lo llamaba nunca.

	//***PARA herramienta dibujo - carga de nomencla */
	//EX 19-09-2026 (fase 2 - paso 3): el alta arranca en '0' y la edicion con el partido que ya tiene el
	//expediente. De los tres estados, `modalPartido` es el unico que se lee: arma la url del geojson del
	//partido y habilita el select de Circ y el boton "+".
	//EX 19-09-2026 (fase 2 - paso 3c): modalCirc y modalSecc se borraron: se escribian en el onChange pero
	//no se leian desde ningun lado.
	const [modalPartido, setModalPartido]=useState(precargarDatos ? partido : '0');

	const [openCatastro, setOpenC] = useState(false);

	//EX 19-09-2026 (fase 2 - paso 3c): aca estaba el estado `open`/`setOpen` ("State para div
	//localizacion"). No se usaba en ningun lado. Se borro.

	//--->30mar2023 - Estados para ventana modal (DRAW)
	const [showDraw, setShowDraw] = useState(false);//cambiar luego a false para que esté apagada por default

	const [nombre_partido, setPartido]=useState([]);

	//EX 18-09-2026 (fase 2 - paso 1): las listas de circ/secc y sus pedidos salen del hook compartido
	//con la edicion (antes cada formulario tenia su propia version y habia divergido).
	const { circS, seccS } = useNomenclador({
		partido,
		circ: datos_20_circ_nomencla,
		//Al cambiar el partido se limpian la circ y la secc elegidas (lo hacia el getCirc de esta
		//pantalla): si no, quedaria seleccionada una circunscripcion del partido anterior.
		onPartidoCambia: () => setInputs({ ...inputs, "datos_20_circ_nomencla": '', "datos_21_secc_nomencla": '' })
	});

	//***** add 07-agos-2023 */
	const [partidoGEO, setPartidoGEO]= useState([]);
	const [geomPartidoEnviar, setGeomPartidoEnviar]=useState(null);

	const urlPartido = `/api/api_serv/query/partidos/?partidoNro=${modalPartido}`;

	const getDatosPartido = async (url) => {

		const headers = {
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		};
		//EX 19-09-2026 (fase 2 - paso 3c): se saca el `const res =`, que no se usaba.
		await fetch(url,{ headers })
		.then(res => res.json())
        .then(res=>{
            setPartidoGEO(res)
        })
		.catch(err => console.log(err));
	}
	//***7-agosto-2023 */

	const [mensajeErrorPrograma, setMensajeErrorPrograma]=useState(true);
	const [mensajeErrorEstado, setMensajeErrorEstado]=useState(true);
	const [mensajeErrorTipo, setMensajeErrorTipo]=useState(true);
	const [mensajeErrorPartido, setMensajeErrorPartido]=useState(true); //valor inicial, mostrar un mensaje para evitar que quede vacio

	useEffect(() =>{
		if (programa === "" || estado === "" || tipo === "" ) {
			setErrorD(true)
		} else if (partido === 0 || partido === '0'){
			setErrorD(true)

		} else{
			setErrorD(false)
		}
	}, [programa, estado, tipo, partido])

	useEffect(()=>{
		if(programa !== ""){
			setMensajeErrorPrograma(false)
		} else {
			setMensajeErrorPrograma(true)
		}
	}, [programa])

	useEffect(()=>{
		if(estado !== ""){
			setMensajeErrorEstado(false)
		} else {
			setMensajeErrorEstado(true)
		}
	}, [estado])

	useEffect(()=>{
		if(tipo !== ""){
			setMensajeErrorTipo(false)
		} else {
			setMensajeErrorTipo(true)
		}
	}, [tipo])

	useEffect(()=>{
		if(partido === 0){
			setMensajeErrorPartido(true)
		} else if(partido !== '0'){
			setMensajeErrorPartido(false)
		} else if(partido === '0'){
			setMensajeErrorPartido(true)
		}
	}, [partido])

	useEffect(() => {
		if(modalPartido !== 0){
			getDatosPartido(urlPartido)
		}
	}, [modalPartido]);

	useEffect(()=>{
        if(partidoGEO === null || partidoGEO.length === 0){
        } else {

            let geojson = partidoGEO[0].geojson;

            let geomHard = JSON.parse(geojson);

            let datos = geomHard;

            setGeomPartidoEnviar(datos);
        }

    }, [partidoGEO])

	useEffect(() => {
		setInputs({ ...inputs, "datos_21_secc_nomencla": '' });
	}, [datos_20_circ_nomencla]);

	//EX 18-09-2026 (fase 2 - paso 1): aca estaba el useEffect que llamaba a getSecc() en
	//[datos_20_circ_nomencla]. Se quito porque el pedido de secciones lo maneja ahora useNomenclador
	//(y ademas ya no se pide nada mientras no haya una circ elegida: punto 7.8).

	useEffect(()=>{

		let partido_name = optionsPartido.filter(partidoN =>{
			//EX 21-09-2026 (paso 7): el == de aca es A PROPOSITO y no hay que "arreglarlo": `partido`
			//puede ser el numero 0 y las opciones traen el valor como string ('0'), asi que con ===
			//no matchearia nunca y quedaria sin etiqueta de partido.
			//eslint-disable-next-line eqeqeq
			return partidoN.value == partido;
		});
		setPartido(partido_name[0].label);

	}, [partido]) // cuando CAMBIE el dato de partido reucperar el dato de la etiqueta

	//EX 18-09-2026 (fase 2 - paso 1): aca estaba getPartido (GET /nomencla/partido para llenar
	//nombre_partido). Se quito porque estaba definida y NUNCA se llamaba desde ningun lado.
	//EX 18-09-2026 (fase 2 - paso 1): getCirc y getSecc se movieron al hook useNomenclador, compartido
	//con la pantalla de edicion. Aca estaban duplicadas y habian divergido.

	//EX 19-09-2026 (fase 2 - paso 3c): aca estaba handleClose, que reseteaba la geometria del contexto y
	//cerraba el modal. No se llamaba desde ningun lado (sus dos referencias estaban comentadas). Se borro.

	const guardarEditRegistro = () => {
		setShowDraw(false);
	}


	/* AGREGAR contadores */
	//** CONTADOR Nomenclatura Sintesis maxNomenclaS**/
	const [maxNomenclaS, setMaxNomenclaS] = useState(500);
	useEffect(()=>{
		const maxNomS = 500;
		if(datos_18_sintesis_nomenclatura){
			if(datos_18_sintesis_nomenclatura !== "" || datos_18_sintesis_nomenclatura !== null){

				var restantesR = maxNomS - datos_18_sintesis_nomenclatura.length;
				setMaxNomenclaS(restantesR);
			}
		} else {
			setMaxNomenclaS(maxNomS);
		}
	}, [datos_18_sintesis_nomenclatura]);
	//** cierra contador Nomencla Sintesis **/

	//****CONTADOR zonificacion****
	{/* const [maxZonif, setmaxZonif] = useState(500);
	useEffect(()=>{
		const maxZonif = 50;
		if(zonificacion){
			if(zonificacion !== "" || zonificacion !== null){
				var restantesR = maxZonif - zonificacion.length;
				setmaxZonif(restantesR);
			}
		} else {
			setmaxZonif(maxZonif);
		}
	}, [zonificacion]); */}
	//----cierra zonificacion---

	//*** CONTADOR Localidades ****
	{/*const [maxLocalidad, setMaxLocalidad] = useState(100);
	useEffect(()=>{
		const maxLoc = 100;
		if(localidad){
			if(localidad !== "" || localidad !== null){
				var restantesR = maxLoc - localidad.length;
				setMaxLocalidad(restantesR);
			}
		} else {
			setMaxLocalidad(maxLoc);
		}
	}, [localidad]);*/}

	//------CIERRA Localidades -----

	//**CONTADOR OBSERV Generales
	const [maxObservGen, setMaxObservGen] = useState(500);
	useEffect(()=>{
		const maxOG = 500;
		if(observaciones_generales){
			if(observaciones_generales !== "" || observaciones_generales !== null){
				var restantesR = maxOG - observaciones_generales.length;
				setMaxObservGen(restantesR);
			}
		} else {
			setMaxObservGen(maxOG);
		}
	}, [observaciones_generales]);
	//---CIERRA-----

	const handleChangeRow = (newRow) =>{
		setFormRows(newRow)
	}

	const onChange = e => {
		cambioOriginal(1);

		const {name, value, type} = e.target;

		if(type === 'textarea' || type === 'text' || type === 'select-one' ){
			setInputs({ ...inputs, [e.target.name]: e.target.value });

			//EX 19-09-2026 (fase 2 - paso 3c): de todo este bloque quedan dos cosas. Se fueron los setters
			//de estados que se borraron (valNomencSintesis, valObserGrales, modalCirc, modalSecc): escribir
			//un estado que nadie lee no hace nada. El vaciado de la circ y la secc al cambiar el partido no
			//se pierde: lo hacen el onPartidoCambia de useNomenclador y el useEffect de
			//datos_20_circ_nomencla.
			if(name === 'partido'){
				setModalPartido(value);
			}

			//EX 19-09-2026 (reportado por el usuario): el auto-alto es SOLO para los textarea y los
			//input de texto. Aca estaba dentro del mismo bloque que el setInputs, que incluye
			//'select-one': un <select> de un solo valor tiene e.target.type === 'select-one', asi que
			//al elegir una opcion entraba tambien y le escribia un height INLINE igual a su
			//scrollHeight (34px medidos), pisando el height:45px que pone SelectInput. Y no se
			//recuperaba nunca: React no vuelve a escribir el estilo si el objeto es igual al
			//anterior, asi que el select quedaba bajito para el resto de la sesion.
			if(type === 'textarea' || type === 'text'){
				e.target.style.height = 'auto';
				e.target.style.height = `${e.target.scrollHeight}px`;
			}

		} else if(type === 'number'){

			if(e.target.name === 'cantidad_lotes'){

				var value_cant_lotes=e.target.value;
				if(e.target.value ===null || e.target.value===""){
					value_cant_lotes=0;
				}
				setInputs({ ...inputs, cantidad_lotes: value_cant_lotes }); //e.target.value 16-02-2023

			} else if(name === 'cantidad_lotes_adjudicables' ) {

				var value_lotes_adj=e.target.value;
				if(e.target.value ===null || e.target.value===""){
					value_lotes_adj=0;
				}

				setInputs({
					...inputs,
					[name]: value_lotes_adj, //e.target.value 16-02-2023
					"porc_lotes_municipales" : 0,
					"lotes_adquiridos_municipio" : 0
				});
				document.getElementById(idInputPorc).value = 0;
				document.getElementById(idInputLotes).value = 0;

			} else if(name === 'lotes_adquiridos_municipio') {

				var value_lotes=e.target.value;
				if(e.target.value ===null || e.target.value===""){
					value_lotes=0;
				}

				setInputs({
					...inputs,
					[name]: value_lotes,
					porc_lotes_municipales : parseInt((value_lotes * 100)/cantidad_lotes_adjudicables) //e.target.value 16-02-2023
				});
			} else if(name === 'porc_lotes_municipales'){
				var value_porc = e.target.value;
				if(e.target.value ===null || e.target.value===""){
					value_porc = 0;
				} else if (e.target.value > 0){
					value_porc = Math.trunc(e.target.value);
				}

				setInputs({
					...inputs,
					[name]: value_porc, //value (16-feb-2023)
					lotes_adquiridos_municipio : (value_porc * cantidad_lotes_adjudicables)/100 //solo_entero (16-feb-2023)
				});
			}

		} else if(e.target.type === 'checkbox'){ //Hay un solo checkbox
			setInputs({ ...inputs, [e.target.name]: e.target.checked });

		} else {
		}
	}

	var buttonClick = (e)=>{
		e.preventDefault();

		setShowDraw(true);
	}


	//EX 19-09-2026 (fase 2 - paso 3): las dos de abajo escriben el valor CALCULADO en los inputs no
	//controlados de porcentaje/lotes (los del onChange de arriba). Las dependencias son las de siempre y
	//estan cambiadas a proposito (una depende del otro campo), asi que no se tocan en este paso; de ahi
	//el eslint-disable: si no, el linter pide agregar justo los campos que se quieren dejar afuera.
	useEffect(()=>{
		document.getElementById(idInputPorc).value = porc_lotes_municipales;
	//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lotes_adquiridos_municipio]);

	useEffect(()=>{
		document.getElementById(idInputLotes).value = lotes_adquiridos_municipio;
	//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [porc_lotes_municipales]);


	const handleChangeDate = (item)=>{
		cambioOriginal(1);
		const fecha = item.value;
		setInputs({ ...inputs, [item.name]: fecha });
	}

	//EX 19-09-2026 (fase 2 - paso 3c): aca estaban onChangeConsulta y su estado `inicial`. No se llamaban
	//desde ningun lado (el grupo de radios con "calcular_cantidad" no existe en el JSX). Se borraron.

	//EX 19-09-2026 (fase 2 - paso 3c): aca estaban, sin usarse nunca, la definicion del componente
	//TextInput y el par activateField/disableField con sus estados active/fieldActivate. Se borraron.

	return (
		<Fragment>

			<div className="container_row">
				<div id="datos_col1" className="container_div_column">{/*columna1*/}
				<div id="E_exp1">{/*  gENERALES  */}

				<div className="h-[30px]">
					<h6 className="mt-4 text-left subtitulos">CARACTERÍSTICAS GENERALES</h6>
				</div>

					<div className="container_left">
						<div className="input-container" >
							<input
								title="Nombre proyecto"
								type="text"
								maxLength="100"
								id="nombre_proyecto"
								name="nombre_proyecto"
								value={valorInicial(nombre_proyecto)}
								onChange={e => onChange(e)}
								required
							/>
							<label for="nombre_proyecto">Nombre proyecto</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<div className="container_left">
						<div className="input-container">
							<input
								title="Expediente"
								type="text"
								maxLength="35"
								id="expediente"
								name="expediente"
								value={valorInicial(expediente)}
								onChange={e => onChange(e)}
								required
							/>
							<label for="expediente">Expediente</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					{/*EX 19-09-2026 (fase 2 - paso 3b): los tres campos de fecha eran 32.5% / 33% / 32.5% con dos
					    separadores vacios de 1%: o sea tres campos practicamente iguales y dos <div> de
					    relleno. Ahora son tres `flex-1` con un `gap-1` (4px, el equivalente al 1% del ancho
					    que tenia la fila). Se usa flex-1 y no `w-*` a proposito: .input-container fija
					    width:100% en index.css y, como las reglas de la app se cargan despues de @tailwind
					    utilities, le ganaria; el flex-basis no choca con width.*/}
					<div className="container_left gap-1">

						<div className="input-container flex-1">
							<DatePicker
								disabled
								className="form-control"
								placeholder=""
								title="fecha_carga"
								name="fecha_carga"
								id="fecha_carga"
								dateFormat="dd/MM/yyyy"
								wrapperClassName="datePicker"
								selected={fechasTalCualVienen ? fecha_carga : _fechaCarga}
								required
							/>
							<label className="label-fecha" for="fecha_carga">Fecha de carga</label>
						</div>{/*cierra ---> input-container */}

						<div className="input-container flex-1">
							<DatePicker
								className="form-control"
								placeholder=""
								title="fecha_caratulacion"
								name="fecha_caratulacion"
								id="fecha_caratulacion"
								dateFormat="dd/MM/yyyy"
								wrapperClassName="datePicker"
								selected={fecha_caratulacion}
								onChange={ (date) => handleChangeDate({ name: "fecha_caratulacion", value: date })}
								required
							/>
							<label className="label-fecha" for="fecha_caratulacion">Fecha de caratulación</label>
						</div>{/*cierra ---> input-container */}

						<div className="input-container flex-1">
							<DatePicker
								disabled
								className="form-control"
								placeholder=""
								title="fecha_actualizacion"
								name="fecha_actualizacion"
								id="fecha_actualizacion"
								dateFormat="dd/MM/yyyy"
								wrapperClassName="datePicker"
								selected={fechasTalCualVienen ? fecha_actualizacion : _fechaHoy} //PARA la primer carga no tiene fecha de actualizacion
								required
							/>
							<label className="label-fecha" for="fecha_actualizacion">Última actualización</label>
						</div>{/*cierra ---> input-container */}

					</div>{/*cierra ---> container_left */}

					{/*EX 19-09-2026 (fase 2 - paso 3b): aca estaba el <div className="container_left"/>
					    VACIO que solo tenia la EDICION entre la fila de fechas y Responsable. No era
					    inerte: .container_left mide 60px de alto mas 12px de margen arriba y abajo, o sea
					    84px de separacion real. Se saca para que los dos flujos tengan el mismo espaciado
					    (el que ya tenia el alta). Si alguna vez hace falta ese aire, va en los dos.*/}

					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="datos_05_responsable"
								id="id_datos_05"
								defaultValue = {datos_05_responsable}
								onChange={e => onChange(e)}
								options={optionsResponsable}
								//className="form-control my-3"
							/>
							<label for="id_datos_05">Responsable</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<Row>
						<Col>
							<div className="container_left !h-[50px]">
								<Form.Check type="checkbox">
									<Form.Check.Input name="tramite_prioritario" defaultChecked={tramite_prioritario} type="checkbox" onChange={e => onChange(e)}/>
									<Form.Check.Label>{`Trámite prioritario`}</Form.Check.Label>
								</Form.Check>
							</div>
						</Col>
						<Col>
							<div className="container_left !h-[50px]">
								<Form.Check type="checkbox">
									<Form.Check.Input name="avanzados" defaultChecked={avanzados} type="checkbox" onChange={e => onChange(e)}/>
									<Form.Check.Label>{`Avanzado`}</Form.Check.Label>
								</Form.Check>
							</div>
						</Col>
					</Row>

					<a className={mensajeErrorPrograma===true ? "text-[0.9em] text-[red]" : "hidden"}>(*) Requerido</a>
					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="programa"
								id="id_programa"
								defaultValue = {programa}
								onChange={e => onChange(e)}
								options={optionsPrograma}
								//className="form-control my-3"
							/>
							<label for="id_programa">Programa</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<a className={mensajeErrorEstado===true ? "text-[0.9em] text-[red]" : "hidden"}>(*) Requerido</a>
					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="estado"
								id="id_estado"
								defaultValue={estado}
								onChange={e => onChange(e)}
								options={optionsEstado}
								className="form-control my-3"
							/>
							<label for="id_estado">Estado</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<a className={mensajeErrorTipo===true ? "text-[0.9em] text-[red]" : "hidden"}>(*) Requerido</a>
					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="tipo"
								id="id_tipo"
								defaultValue={tipo}
								onChange={e => onChange(e)}
								options={optionsTipo}
								//className="form-control my-3"
							/>
							<label for="id_tipo">Tipo</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<a className={mensajeErrorPartido===true ? "text-[0.9em] text-[red]" : "hidden"}>(*) Requerido</a>
					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="partido"
								id="id_partido"
								defaultValue={partido}
								onChange={e => onChange(e)}
								options={optionsPartido}
								//EX 18-09-2026: en la EDICION el partido queda bloqueado (partidoBloqueado). La
								//nomenclatura depende de el: las circunscripciones/secciones elegidas y las filas
								//de DATOS CATASTRALES Y DOMINIALES guardan su propio nomencla_partido, asi que
								//cambiarlo dejaria esos datos apuntando al partido anterior.
								disabled={partidoBloqueado}
								//className="form-control my-3"
							/>
							<label for="id_partido">Partido</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<div className="container_left">
						<div className="input-container">
							<input
								title="Localidad"
								type="text"
								name="localidad"
								maxLength="100"
								id="localidad"
								value={valorInicial(localidad)}
								onChange={e => onChange(e)}
								required
							/>
							<label for="localidad">Localidad</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}


					{/*EX 19-09-2026 (fase 2 - paso 3b): esta fila ya estaba bien armada (48% + 48% con un
					    separador del 4% = 100% exacto, gracias al width:48% de .input-number-45), asi que
					    lo unico que se hizo fue cambiar el <div> separador por un gap del mismo 4%.*/}
					<div className="container_left gap-[4%]">
						<div className="input-number-45">
							<input title="Cantidad de lotes" type="number" name="cantidad_lotes" id="id_cant_lotes" value={valorInicial(cantidad_lotes)} onChange={e => onChange(e)} />
							<label for="id_cant_lotes">Cantidad de lotes</label>
						</div>{/*cierra ---> input */}

						<div className="input-number-45">
							<input
								title="Cantidad de Lotes Adjudicables"
								type="number"
								id="id_cant_lotes_adj"
								name="cantidad_lotes_adjudicables"
								defaultValue={valorInicial(cantidad_lotes_adjudicables)}
								onChange={e => onChange(e)} //USAR una sola función
							/>
							<label for="id_cant_lotes_adj">Cantidad de lotes adjudicables</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}


					<div className="container_left gap-[4%]">
						<div className="input-number-45">
							<input
								title="Porcentaje Lotes Municipales"
								id={idInputPorc}
								type="number"
								min="0"
								max="100"
								name="porc_lotes_municipales"
								step="1"
								defaultValue={valorInicial(porc_lotes_municipales)}
								onChange={e => onChange(e)}
							/>
							<label for={idInputPorc}>Porcentaje lotes municipales</label>
						</div>{/*cierra ---> input-number-45 */}

						<div className="input-number-45">
							<input
								title="Lotes Adquiridos por Municipio"
								id={idInputLotes}
								type="number"
								name="lotes_adquiridos_municipio"
								step="0.01"
								defaultValue={valorInicial(lotes_adquiridos_municipio)}
								onChange={e => onChange(e)}
							/>
							<label for={idInputLotes}>Lotes adquiridos por municipio</label>
						</div>{/*cierra ---> input-number-45 */}
					</div>{/*cierra ---> container_left */}


					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="sistema_agua"
								id="id_sistema_agua"
								defaultValue={valorInicial(sistema_agua)}
								onChange={e => onChange(e)}
								options={optionsSistemaAgua}
							/>
							<label for="id_sistema_agua" >Sistema de agua</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="eliminacion_excretas"
								id="id_eliminacion_excretas"
								defaultValue={valorInicial(eliminacion_excretas)}
								onChange={e => onChange(e)}
								options={optionsEliminacionExcret}
							/>
							<label for="id_eliminacion_excretas" >Eliminación de excretas</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

				</div>{/* cierra id="E_exp1" */}
				</div>{/*cierra columna1*/}

				<div id="datos_col2" className="container_div_column">{/*columna2 col DOS*/}
					<div id="E_exp2">{/*  Catastrales  */}
						<div
							className="h-[30px]"
							onDoubleClick={() => setOpenC(!openCatastro)}
							aria-controls="example-collapse-textC"
							aria-expanded={openCatastro}
						>
							<h6 className="mt-4 text-left subtitulos">DATOS CATASTRALES Y DOMINIALES {openCatastro ? "(doble click para cerrar...)" : "(doble click para abrir...)"}</h6>
						</div>

						<div>
							{/*EX 19-09-2026 (fase 2 - paso 3b): la fila del nomenclador queda con UNA sola
							    geometria para los dos flujos. Antes cada flujo tenia sus anchos (el alta
							    60/25/25/10 y la edicion 40/25/40/sin ancho): los dos sumaban mas de 100% y
							    andaban solo porque el flex los encogia, y los separadores eran 6 <div>
							    vacios. Ahora los separadores son un `gap` y el ancho de cada campo es una
							    PROPORCION.
							    Se usa flex-basis (basis-0 + grow-[N]) y no `w-[...]` a proposito:
							    .input-number fija width:50% en index.css y, como las reglas propias de la
							    app se cargan DESPUES de @tailwind utilities, le ganaria al w-[...]. El
							    flex-basis no choca con eso: en una fila flex le gana a width.
							    Ojo con `!h-auto`: .container_left fija height:60px y ahi SI hay conflicto
							    (esa fila tiene que medir lo que mida su contenido).*/}
							<div className="container_left gap-2 !h-auto" >
								<div className="input-number basis-0 grow-[2] min-w-0" disabled>
									<input name="partido_nombre" id="id_nomcla_circ" value={nombre_partido}></input>
									<label for="id_nomcla_circ">Partido</label>
								</div>

								<div className="input-number basis-0 grow-[1] min-w-0">
									<SelectInput
										name="datos_20_circ_nomencla"
										id="id_circ_T"
										//EX 19-09-2026 (fase 2 - paso 3): la edicion usa este select CONTROLADO
										//(value) y el alta no controlado (defaultValue). En la edicion hace falta
										//que sea controlado para que se vea el vaciado de la circ y la secc cuando
										//cambia la lista; en el alta la lista se recarga entera y alcanza con el
										//valor por defecto.
										{...(precargarDatos
											? { value: datos_20_circ_nomencla }
											: { defaultValue: datos_20_circ_nomencla })}
										onChange={e => onChange(e)}
										options={circS}
										//className="form-control my-3"
									/>
									<label for="id_circ_T">Circ.</label>
								</div>

								<div className="input-number basis-0 grow-[1] min-w-0">
									<SelectInput
										name="datos_21_secc_nomencla"
										id="id_secc_T"
										{...(precargarDatos
											? { value: datos_21_secc_nomencla }
											: { defaultValue: datos_21_secc_nomencla })}
										onChange={e => onChange(e)}
										options={seccS}
										className="form-control my-3"
									/>
									<label for="id_secc_T">Secc.</label>
								</div>

								<div className="shrink-0">
									<Button form='my-form' type="button" disabled={modalPartido ==='0' ? true : false} className="btn btn-success btn-block button_verde" onClick={buttonClick}>+</Button>
								</div>

							</div>{/*cierra ---> container_left */}


							<div className={"input-container" + (nameLogin === "javi1" ? "" : " !hidden")}>
								<textarea
									type="text"
									//maxLength="500"
									name="datos_22_geom"//sintesis_nomencla
									value={JSON.stringify(geom)}
									//ref={textGeom}
									onChange={e => onChange(e)}
									rows={5}
								/>
								<label>Datos catastarales - geojson</label>
							</div>{/*cierra ---> input-container */}
						</div>

						<div className="container_left !h-auto">
							<div className="input-container">
								<textarea
									type="text"
									maxLength="500"
									name="datos_18_sintesis_nomenclatura"//sintesis_nomencla
									defaultValue={valorInicial(datos_18_sintesis_nomenclatura)}
									onChange={e => onChange(e)}
									rows={5}
									//className="form-control my-3"
								/>
								<label>Datos catastrales y dominiales - Síntesis</label>
								<p className="text-right h-[5px] text-[0.9em]">Caracteres restantes: {maxNomenclaS}</p>
							</div>{/*cierra ---> input-container */}
						</div>{/*cierra ---> container_left */}


						<Collapse in={openCatastro}>
							<div id="example-collapse-textC">
								<TablaCampos  formRows={formRows} setFormRows={handleChangeRow}/>
							</div>
						</Collapse>
					</div>{/*cierra E_exp2 */}

					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="titular_tierra"
								id="id_titular_tierra"
								defaultValue={valorInicial(titular_tierra)}
								onChange={e => onChange(e)}
								options={optionsTitular}
							/>
							<label for="id_titular_tierra">Titular de la tierra</label>
						</div>{/*cierra container_left*/}
					</div>{/* cierra input-container */}

					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="plano_oficial"
								id="id_plano_oficial"
								defaultValue={valorInicial(plano_oficial)}
								onChange={e => onChange(e)}
								options={optionsPlano}
							/>
							<label for="id_plano_oficial">Plano oficial</label>
						</div>{/*cierra container_left*/}
					</div>{/* cierra input-container */}

					<div className="container_left">
						<h6 className="mt-4 text-left subtitulos">LOCALIZACIÓN SEGÚN ORDENANZA VIGENTE</h6>
					</div>

					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="area"
								id="id_area"
								defaultValue={valorInicial(area)}
								onChange={e => onChange(e)}
								options={optionsArea}
								className="form-control my-3"
							/>
							<label for="id_area">Área</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<div className="container_left">
						<div className="input-container">
							<input
								//placeholder="Zonificacion"
								id="zonificacion"
								type="text"
								maxLength="50"
								name="zonificacion"
								value={valorInicial(zonificacion)}
								onChange={e => onChange(e)}
								//className="form-control my-3"
								required
							/>
							<label for="zonificacion">Zonificación</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<div className="container_left">
						<div className="input-container">
							<input
								title="Nro. ordenanza vigente"
								type="text"
								maxLength="200"
								id="id_nro_ord_vigente"
								name="nro_ordenanza_vigente"
								value={valorInicial(nro_ordenanza_vigente)}
								onChange={e => onChange(e)}
							/>
							<label for="id_nro_ord_vigente">Nro. ordenanza vigente</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<div className="container_left">
						<div className="input-container">
							<input
								title="Decreto Promulgatorio"
								type="text"
								maxLength="200"
								id="id_decreto_prom"
								name="decreto_promulgatorio"
								defaultValue={valorInicial(decreto_promulgatorio)}
								onChange={e => onChange(e)}
							/>
							<label for="id_decreto_prom">Decreto promulgatorio</label>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

					<div className="container_left !h-auto">
						<div className="input-container">
							<textarea
								type="text"
								maxLength="500"
								name="observaciones_generales"
								id="observaciones_generales"
								defaultValue={valorInicial(observaciones_generales)}
								onChange={e => onChange(e)}
								rows={5}
							/>
							<label for="observaciones_generales">Observaciones generales</label>
							<p className="text-right h-[5px] text-[0.9em]">Caracteres restantes: {maxObservGen}</p>
						</div>{/*cierra ---> input-container */}
					</div>{/*cierra ---> container_left */}

				</div>{/*cierra columna2*/}

			</div>{/*****cierra 1er DIV container-row*******/}

			<Modal
				id={idModalMapa}
				show={showDraw}
				backdrop="static"
				keyboard={false}
				className="id_modal_map"
				//EX 19-09-2026: se quito style={{top: "200"}}. Es herencia vieja y en un modal fullscreen
				//(que ya ocupa el 100% del alto) empujaba todo 200px hacia abajo, dejando el dialogo mas alto
				//que la ventana: de ahi el desplazamiento y que el contenido no coincidiera con el borde del
				//modal (espacio libre de un lado y pegado del otro).
				size="fullscreen"
			>
				{/*EX 19-09-2026 (fase 2 - paso 3b): el color va por clases. Aca si puede ganar Tailwind
				    porque bootstrap.min.css se importa ANTES que index.css (index.js:1 y :5).*/}
				<Modal.Header className="bg-[rgb(0,174,195)] text-white">
					<Modal.Title>{tituloMapa}</Modal.Title>
				</Modal.Header>
				<Modal.Body><MapExpedientes partido={partido} circ={datos_20_circ_nomencla} secc={datos_21_secc_nomencla} partidoGEO={geomPartidoEnviar}/></Modal.Body>
				<Modal.Footer>
					<Button className="btn btn-success btn-block button_verde" onClick={guardarEditRegistro} disabled="">Salir</Button>
				</Modal.Footer>
			</Modal>


		</Fragment>
	)
};

export default DatosExp;
